import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { from, Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { AuthService } from "../services/auth/user-auth/auth.service";
import { ExternalAuthService } from "../services/auth/external-auth/external-auth.service";
import { DomainService } from "../services/domain/domain.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthService,
    private externalAuthService: ExternalAuthService,
    private domainService: DomainService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const domain = this.domainService.domain;
    const subdomain = this.domainService.subdomain;
    const isInternal = this.domainService.isInternal;
    const isExternalTokenRequest = request.url.startsWith(`${environment.apiUrl}/core/cliente/token`);

    if (!request.url.startsWith(environment.apiUrl)) {
      return next.handle(request);
    }

    if (!subdomain) {
      return next.handle(request);
    }

    if (isInternal) {
      const currentUser = this.authenticationService.currentUserValue;
      return next.handle(this.attachAuthorization(request, currentUser?.token ?? null));
    }

    if (isExternalTokenRequest) {
      return next.handle(request);
    }

    return from(this.externalAuthService.getTokenForRequest()).pipe(
      switchMap((token) => next.handle(this.attachAuthorization(request, token)))
    );
  }

  private attachAuthorization(request: HttpRequest<any>, token: string | null): HttpRequest<any> {
    if (!token) {
      return request;
    }

    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
